import { Tag, useTestIds } from "@homebound/beam";
import { Link } from "react-router-dom";
import { NamedFragment } from "src/fragments/commonFragments.generated";
import { ActionItemTypes } from "../enums";
import { getTaskParentTitleAndUrl } from "../utils";

// generic component to render a tag with a link to the task parent's schedule
export function TaskParentTag({ taskParent, actionType }: { taskParent: NamedFragment; actionType?: ActionItemTypes }) {
  const { parentTitle, url } = getTaskParentTitleAndUrl(taskParent);
  const tids = useTestIds({}, actionType);
  return (
    <Link to={url}>
      <Tag text={parentTitle} {...tids.taskParentTag} />
    </Link>
  );
}
